export interface SupersearchItemPayload {
  uuid?: string
  id?: string
  name?: string
  title?: string
  sku?: string
  email?: string
  status?: string
  content?: string
  label?: string
  full_address?: string
  // Personal entity filtering
  created_by_uuid?: string   // Tasks, Notes, Projects
  owner_uuid?: string        // Projects
  // Note context (personal, crm, flash_report)
  context?: 'personal' | 'crm' | 'flash_report'
  // Project context and type
  projectable_type?: string  // For projects: 'App\Models\User', 'App\Models\SubAccount', etc.
  // Parent entity info
  parent_type?: 'project' | 'account' | 'sub-account' | 'user'
  parent_uuid?: string
  parent_name?: string
  parent_link?: string
  [key: string]: any
}

export interface SupersearchItem {
  link: string // API detail link, e.g. "/api/products/{uuid}"
  item: SupersearchItemPayload
}

export interface SupersearchDomain {
  domain: string // e.g. "products", "accounts"
  results: SupersearchItem[]
}

export interface SupersearchResponse {
  data: SupersearchDomain[]
  total: number
  query: string
  limit_per_model: number
}

export const SUPERSEARCH_DOMAIN_LABELS: Record<string, string> = {
  'products': 'Products',
  'accounts': 'Accounts',
  'sub-accounts': 'Sub-Accounts',
  'tasks': 'Tasks',
  'personal-tasks': 'Personal Tasks',
  'projects': 'Projects',
  'personal-projects': 'Personal Projects',
  'addresses': 'Addresses',
  'notes': 'Notes',
  'personal-notes': 'Personal Notes',
  'users': 'Users',
  'bug-reports': 'Bug Reports',
  'operations-jobs': 'Operations Jobs',
  'sales-history': 'Sales History',
  'design-jobs': 'Design Jobs',
  'inquiries': 'Inquiries (Amazon)',
  'local-inquiries': 'Local Inquiries',
  'walmart-inquiries': 'Walmart Inquiries',
}


